var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("registration-form", {
    attrs: { submitButtonText: "Зарегистрироваться" },
    on: { success: _vm.isSuccess },
    scopedSlots: _vm._u(
      [
        false
          ? {
              key: "offer",
              fn: function() {
                return [
                  _c("div", { staticClass: "registration-form__hardware" }, [
                    _c("p", [
                      _vm._v(
                        "Заполните данные о вашем оборудовании сейчас и получите 200 бонусов на оплату заказа"
                      )
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: _vm.hardwareLink } }, [
                      _vm._v("Заполнить")
                    ])
                  ])
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "term",
          fn: function() {
            return [
              _c("div", { staticClass: "registration-form__hint" }, [
                _c("p", [
                  _vm._v(
                    "Нажимая кнопку вы соглашаетесь на обработку ваших персональных данных на следующих "
                  ),
                  _c(
                    "a",
                    { attrs: { href: _vm.termsLink, target: "_blank" } },
                    [_vm._v("условиях")]
                  ),
                  _vm._v(".")
                ])
              ])
            ]
          },
          proxy: true
        },
        {
          key: "success",
          fn: function() {
            return [
              _vm.success
                ? _c("div", { staticClass: "registration-form__success" }, [
                    _c("p", [_vm._v("Регистрация прошла успешно!")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-block btn-main",
                        attrs: { href: "/personal/profile/" }
                      },
                      [_vm._v("Личный кабинет")]
                    )
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }